import React, {useState} from 'react';
import TabBasic from "../../../components/tabs/TabBasic";
import RentalAssetHistory from "./subPage/RentalAssetHistory";
import RentalRequestHistory from "./subPage/RentalRequestHistory";
import RentalRequestHistoryList from "./subPage/RentalRequestHistoryList";
import {
    getRentalRequestHistories,
    getRentalRequestHistoriesForRentalAsset
} from "../../../api/lifecycle/rental/rentalHistoryService";

const RentalHistory = ({rentalInfo, showRentalRequestHistory}) => {
    const [tabAttribute, setTabAttribute] = useState(() => {
        if (showRentalRequestHistory) {
            return [
                { clicked: true, name: "대여신청 상세이력" },
            ];
        } else {
            return [
                { clicked: true, name: "대여자산 이력" },
                { clicked: false, name: "대여신청 이력" },
                { clicked: false, name: "대여신청 상세이력" },
            ];
        }
    });

    return (
        <div style={{display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0}}>
            <>
                <TabBasic args={tabAttribute} setArgs={setTabAttribute}/>
                {showRentalRequestHistory
                    ?
                    <>
                        {tabAttribute[0].clicked && <RentalRequestHistory rentalAssetId={rentalInfo.id} fetchMethod={getRentalRequestHistories}/>}
                    </>
                    :
                    <>
                        {tabAttribute[0].clicked && <RentalAssetHistory rentalAssetId={rentalInfo.id}/>}
                        {tabAttribute[1].clicked && <RentalRequestHistoryList rentalAssetId={rentalInfo.id}/>}
                        {tabAttribute[2].clicked && <RentalRequestHistory rentalAssetId={rentalInfo.id} fetchMethod={getRentalRequestHistoriesForRentalAsset}/>}
                    </>
                }
            </>
        </div>
    );
};

export default RentalHistory;